import { Box, Button, Modal, TextArea, TextField } from '@servicepipe/ui-components';
import React from 'react';
import { toast } from 'react-toastify';

export const ModalLinkUser = ({ isShow, onClose, link }) => {
  const handleCopy = async () => {
    if (link && navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(link);
        toast.success('Copied');
        onClose();
      } catch (err) {
        toast.error(err.message);
      }
      return;
    }

    if (!link) {
      return;
    }

    const textArea = document.createElement('textarea');
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    toast.success('Copied');
    onClose();
  };

  if (!isShow || !link) {
    return null;
  }

  return (
    <Modal enableMaximize={false} size="s" title="Invitation link" toggle={onClose}>
      <Box direction="column" gap="15px" width="365px">
        <TextField label="Link">
          <TextArea value={link} />
        </TextField>

        <Box width="100%" align="center" gap="16px" justify="right">
          <Button onClick={handleCopy} variant="solid" color="accent" type="button">
            Copy
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
